import axios from "axios";
import { HEADERS } from "../../../../API/UrlAndPaths";
import store from "../../../../Redux/store";
import { getIAreportList, setStockMove, setStockMoveSigleView } from "./ReportSlice";
import { setSubmitLoading, setTableLoadingGlobal } from "../../../../Redux/Dashboard/mainDashBoardSlice";
import { errorSnackMsg } from "../../../Custom Hooks/SnackkBarUtilities";

export const StockMoveAPIcall=async(body)=>{
    store.dispatch(setTableLoadingGlobal(true))
    await axios
    .post("inventory/stockMoveReport",body, HEADERS)
    .then((res)=>{
        store.dispatch(setTableLoadingGlobal(false))
        if(res.status===200){
            store.dispatch(setStockMove({stockMoveList:res.data}))
        }
    })
    .catch((err)=>{
        store.dispatch(setStockMove({stockMoveList:undefined}))
        store.dispatch(setTableLoadingGlobal(false))
    })
}

export const StockMoveSingleAPIcall=async(body)=>{
    store.dispatch(setSubmitLoading(true))
    await axios
    .post("inventory/stockMoveReportSingleView",body, HEADERS)
    .then((res)=>{
        if(res.status===200){
            store.dispatch(setSubmitLoading(false))
            store.dispatch(setStockMoveSigleView({stockMoveSingleList:res.data}))
        }
    })
    .catch((err)=>{
        store.dispatch( setStockMoveSigleView({stockMoveSingleList:[]}))
        store.dispatch(setSubmitLoading(false))
    })

}

// export const IAreportAPI = async (body) => {
//   store.dispatch(setSubmitLoading(true));
//   try {
//     // Manually construct query string with raw spaces
//     const queryParams = [];

//     if (body.branchId) queryParams.push(`branchId=${body.branchId}`);
//     if (body.locationId) queryParams.push(`locationId=${body.locationId}`);
//     if (body.fromDate) queryParams.push(`fromDate=${body.fromDate}`); // space allowed
//     if (body.endDate) queryParams.push(`endDate=${body.endDate}`);

//     if (Array.isArray(body.itemType)) {
//       body.itemType.forEach(id => {
//         queryParams.push(`itemType=${id}`);
//       });
//     }

//     const queryString = queryParams.join('&');
//     const fullUrl = `http://192.168.1.57:3100/report/iAReport?${queryString}`;

//     // Send raw URL without re-encoding
//     const { res } = await axios({
//       method: 'get',
//       url: fullUrl,
//       headers: HEADERS,
//       transitional: {
//         forcedJSONParsing: false
//       }
//     });
//  console.log(res," data from iA reporxxxt");
//     if (res.success) {
//         console.log(res," data from iA report");
//       store.dispatch(getIAreportList({ iaReportList: res.data }));
//     }
//   } catch (err) {
//     store.dispatch(getIAreportList({ iaReportList: [] }));
//     errorSnackMsg("Error fetching data !!");
//   } finally {
//     store.dispatch(setSubmitLoading(false));
//   }
// };
export const IAreportAPI = async (body) => {
  store.dispatch(setTableLoadingGlobal(true))
   store.dispatch(setSubmitLoading(true))
  try {
    const response = await axios.get("report/iAReport", { 
      params: body,
      headers: HEADERS.headers
    });
    
    if (response.data.success) {
      store.dispatch(getIAreportList({ iaReportList: response.data.data }));
      store.dispatch(setTableLoadingGlobal(false))
       store.dispatch(setSubmitLoading(false))
    }
  } catch (err) {
    console.error("Error fetching data:", err);
    store.dispatch(getIAreportList({ iaReportList: [] })); 
    errorSnackMsg("Error fetching data!!");
    store.dispatch(setTableLoadingGlobal(false))
     store.dispatch(setSubmitLoading(false))
  } finally {
    store.dispatch(setTableLoadingGlobal(false))
     store.dispatch(setSubmitLoading(false))
  }
};



